<form nz-form nzLayout="vertical" (ngSubmit)="handleOk()">
  <nz-descriptions class="block-user-modal__header" nzSize="small" [nzBordered]="true" [nzColumn]="1">
    <nz-descriptions-item [nzTitle]="'adminUsers.user' | translate">{{ username }}</nz-descriptions-item>
  </nz-descriptions>

  <nz-form-item>
    <nz-form-label>{{ 'adminUsers.blockComment' | translate }}</nz-form-label>
    <nz-form-control [nzExtra]="'adminUsers.blockCommentHint' | translate">
      <textarea nz-input rows="3" maxlength="500" [formControl]="commentControl"></textarea>
    </nz-form-control>
  </nz-form-item>
</form>
